import * as ST from './styled';

interface ICarouselProps {
    children: React.ReactNode,
}

const Carousel = ({ children }: ICarouselProps): JSX.Element => {
    return (
        <ST.Carousel cellSpacing={0} withoutArrows autoplay wrapAround>{children}</ST.Carousel>
    );
};

export default Carousel;
